import { render, staticRenderFns } from "./DirectionSelection.vue?vue&type=template&id=4fa252d7"
import script from "./DirectionSelection.vue?vue&type=script&setup=true&lang=ts"
export * from "./DirectionSelection.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports